export default "__VITE_ASSET__7f609f36__"